// assets/fade-in.js
(function () {
  'use strict';

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  function onIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-visible');
        // smetti di osservare per migliorare le performance
        observer.unobserve(entry.target);
      }
    });
  }

  function initFadeIn() {
    const sections = document.querySelectorAll('.shopify-section');
    if (!sections.length) return;

    // fallback per browser vecchi
    if (!('IntersectionObserver' in window)) {
      sections.forEach(s => s.classList.add('fade-in-visible'));
      return;
    }

    const observer = new IntersectionObserver(onIntersect, observerOptions);
    sections.forEach(section => {
      // aggiungi classe iniziale solo se non è già presente
      if (!section.classList.contains('fade-in-hidden') &&
          !section.classList.contains('fade-in-visible')) {
        section.classList.add('fade-in-hidden');
      }
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeIn);
  } else {
    initFadeIn();
  }
})();
